import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function HotArticlesSection() {
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 6);

  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6">
        {/* 区块标题 */}
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between mb-10 gap-4">
          <div>
            <span className="text-xs font-semibold tracking-widest uppercase text-secondary-500">HOT TOPICS</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-1">
              热门爆料文章
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-lg">
              全网最热网红塌房事件追踪，吃瓜群众不可错过的精彩爆料
            </p>
          </div>
        </div>

        {/* 文章卡片网格 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {hotArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              {/* 图片区 */}
              <div className={`relative aspect-[16/10] overflow-hidden ${index === 0 ? 'bg-primary-100' : 'bg-secondary-100'}`}>
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-full">
                    {article.category}
                  </span>
                </div>
                {article.isFeatured && (
                  <div className="absolute top-3 right-3">
                    <span className="inline-block px-2 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full">
                      置顶
                    </span>
                  </div>
                )}
              </div>

              {/* 内容区 */}
              <div className="flex flex-col flex-1 p-4 md:p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-500 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2 mb-4 leading-relaxed flex-1">
                  {article.excerpt}
                </p>

                {/* 数据行 */}
                <div className="flex items-center justify-between text-xs text-foreground-500 mb-4">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {(article.readCount / 10000).toFixed(1)}万
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line" />
                    {article.commentCount}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line" />
                    {article.likeCount}
                  </span>
                  <span className="text-foreground-400">{article.publishDate}</span>
                </div>

                {/* 按钮 */}
                <span className={`whitespace-nowrap block text-center w-full py-2.5 rounded-full text-sm font-semibold transition-all duration-200 ${
                  index === 0
                    ? 'bg-primary-500 text-background-50 group-hover:bg-primary-600'
                    : 'bg-transparent border border-foreground-300 text-foreground-700 group-hover:border-primary-300 group-hover:text-primary-500'
                }`}>
                  阅读全文
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}